import { render, staticRenderFns } from "./AdminSlugFieldComponent.vue?vue&type=template&id=dc443772"
import script from "./AdminSlugFieldComponent.vue?vue&type=script&lang=js"
export * from "./AdminSlugFieldComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports